<div class="w-full h-full p-1">
      <p-dialog [draggable]="false" [visible]="configMissing" [closable]="false" appendTo="self">
    <i class="pi pi-exclamation-circle pr-1"></i> <label>{{ disabledMessage }}</label> <br />
    <br />
  </p-dialog>

    <app-tool-loader [isLoading]="isLoading()" positionUnset="true">
        <p-scrollPanel [style]="{ width: '100%', height: '92%' }">
            <form [formGroup]="risersForm">

                <div [class.opacity-50]="configMissing" [class.pointer-events-none]="configMissing" class="pb-3">
                <p-checkbox
                    size="small" 
                    formControlName="includeRiser"
                    inputId="includeRiserCmp"
                    binary="true"
                    (onChange)="hasRiserChange()"
                    ></p-checkbox>
                    <label class="pl-2" for="includeRiserCmp">Riser Installed</label>
                </div>

                <p-fieldset legend="Riser" formGroupName="riser" [class.opacity-50]="!riserIncluded" [class.pointer-events-none]="!riserIncluded">
                    <div class="space-y-2">
                        <div class="flex flex-col">
                        <label for="outsideDiameter">Outside Diameter</label>
                        <p-inputgroup>
                            <p-inputnumber required="" [minFractionDigits]="1" formControlName="outsideDiameter" />
                            <p-inputgroup-addon>{{ pipeRoughnessUnit }}</p-inputgroup-addon>
                        </p-inputgroup>
                        </div>

                        <div class="flex flex-col">
                        <label for="outsideDiameter">Inside Diameter</label>
                        <p-inputgroup>
                            <p-inputnumber required="" [minFractionDigits]="1" formControlName="insideDiameter" />
                            <p-inputgroup-addon>{{ pipeRoughnessUnit }}</p-inputgroup-addon>
                        </p-inputgroup>
                        </div>
                    </div>
                </p-fieldset>

                <div [class.opacity-50]="!riserIncluded" [class.pointer-events-none]="!riserIncluded" class="flex items-end gap-2" formGroupName="riser">
                    <div class="flex-1">
                        <label class="mb-2">Wellhead/Housing connector location</label>
                        <p-select placeholder="Select" required formControlName="attachedTubularId" optionLabel="label" optionValue="value" [options]="tubulars" appendTo="body" class="w-full"></p-select>
                    </div>
                </div>
            </form>

        </p-scrollPanel>

    </app-tool-loader>
</div>